import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, Router } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { SingleWorkComponent } from './components/works/single-work/single-work.component';
import { WorksComponent } from './components/works/works.component';
import { ReelsComponent } from './components/reels/reels.component';
import { CompanyComponent } from './components/company/company.component';
import { ApplicationStateService } from './services/application-state.service';
import { ConnectComponent } from './components/connect/connect.component';

const routes: Routes = [
    { path: '', redirectTo: '/', pathMatch: 'full' },
    { path: '', component: HomeComponent, data: { animation: 'HomePage' } },
    {
        path: 'works', component: WorksComponent, data: { animation: 'WorksPage' },
        children: [
            { path: ':slug', component: SingleWorkComponent },
        ]
    },
    // { path: 'reels', component: ReelsComponent, data: { animation: 'ReelsPage' } },
    { path: 'reels', redirectTo: '/', pathMatch: 'full'},
    { path: 'company', component: CompanyComponent, data: { animation: 'CompanyPage' } },
    { path: 'connect', component: ConnectComponent },
];

const mobile_routes = [
    { path: '', redirectTo: '/', pathMatch: 'full' },
    { path: '', component: HomeComponent, data: { animation: 'HomePage' } },
    { path: 'works', component: WorksComponent, data: { animation: 'WorksPage' } },
    { path: 'works/:slug', component: SingleWorkComponent },
    { path: 'reels', redirectTo: '/', pathMatch: 'full'},
    // { path: 'reels', component: ReelsComponent, data: { animation: 'ReelsPage' } },
    { path: 'company', component: CompanyComponent, data: { animation: 'CompanyPage' } },
    { path: 'connect', component: ConnectComponent },
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule {
    public constructor(private router: Router,
        private applicationStateService: ApplicationStateService) {
        if (this.applicationStateService.getIsMobileResolution()) {
            this.router.resetConfig(mobile_routes);
        }
    }
}